import { render } from "./EditEmployeeReport.vue?vue&type=template&id=2df7cd8e&scoped=true"
import script from "./EditEmployeeReport.vue?vue&type=script&lang=js"
export * from "./EditEmployeeReport.vue?vue&type=script&lang=js"

import "./employee-report.scss?vue&type=style&index=0&id=2df7cd8e&lang=scss&scoped=true"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df7cd8e"]])

export default __exports__